import Clarity from '@microsoft/clarity'

const projectId = import.meta.env.VITE_CLARITY_PROJECT_ID

export function initClarity() {
  if (!projectId) {
    // No project id configured (e.g. local dev) — skip to avoid polluting analytics.
    return
  }

  Clarity.init(projectId)
}

export function identifyClarityUser(customId: string) {
  if (!projectId) {
    return
  }

  Clarity.identify(customId)
}
